import { createFileRoute } from '@tanstack/react-router';
import { GroupingRuleSetTypes } from '@views/Settings/GroupingRules/types';
import { APP_PATHS, PAGE_PATHS } from '../../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/settings/rule-set/$id/{-$ruleIndex}/')({
  staticData: {
    groupingRuleType: GroupingRuleSetTypes.Violation_Tickets,
  },
  beforeLoad: ({ context, preload }) => {
    const isAllowed = context.userPermissions.hasAllowedPermission({ app: APP_PATHS.ASSETS, path: PAGE_PATHS.RULE_SET });
    context.validatePermissions({ isAllowed, preload });
  },
});
